import React from 'react';
import { matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';
import FormButton from '@app/component/form/button/FormButton';
import Utilities from '@util/Utilities';
import { BuildingOfficeIcon, InboxIcon, RectangleGroupIcon } from '@heroicons/react/24/outline';
import ReviewsProvider from '@app/site/secured/review-manager/provider/ReviewsProvider';

const ReviewManagerDashboardPage = React.memo(() => {

	const navigate = useNavigate();
	const location = useLocation();

	const isInbox = !!matchPath('/secured/review-manager/inbox', location.pathname);
	const isPropertyOverview = !!matchPath('/secured/review-manager/property-overview/*', location.pathname);
	const isGroupOverview = !!matchPath('/secured/review-manager/group-overview', location.pathname);

	return <>
		<header className="bg-white shadow-sm">
			<div className="mx-auto max-w-7xl py-4 px-4 sm:px-6 lg:px-8">
				<div className="md:flex md:items-center md:justify-between">
					<div className="min-w-0 flex-1">
						<h1 className="text-lg font-semibold leading-6 text-gray-900">
							Review Manager
						</h1>
					</div>
					<div className="md:hidden">
						<div className="mt-1">
							<select aria-label="Select a tab" className="w-full input"
											onChange={(e) => navigate(e.target.value)}>
								<option value="/secured/review-manager/inbox" selected={isInbox}>Review Inbox</option>
							</select>
						</div>
					</div>
					<div className="hidden md:block">
						<div className="mt-4 md:flex space-y-2 md:space-y-0 md:space-x-2.5 md:ml-4 md:mt-0">
							<div>
								<FormButton state="white" isLink to="/secured/review-manager/inbox"
														extraClassName={Utilities.classNames('font-normal py-1.5', isInbox ? ' text-blue-700 bg-blue-50' : '')}>
									<InboxIcon className="w-4 h-4 mr-2" />
									Reviews Inbox
								</FormButton>
							</div>
							<div>
								<FormButton state="white" isLink to="/secured/review-manager/property-overview/insights"
														extraClassName={Utilities.classNames('font-normal py-1.5', isPropertyOverview ? ' text-blue-700 bg-blue-50' : '')}>
									<BuildingOfficeIcon className="w-4 h-4 mr-2" />
									Property Overview
								</FormButton>
							</div>
							<div>
								<FormButton state="white" isLink to="/secured/review-manager/group-overview"
														extraClassName={Utilities.classNames('font-normal py-1.5', isGroupOverview ? ' text-blue-700 bg-blue-50' : '')}>
									<RectangleGroupIcon className="w-4 h-4 mr-2" />
									Group Overview
								</FormButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
		<ReviewsProvider>
			<Outlet />
		</ReviewsProvider>
	</>;

});


export default ReviewManagerDashboardPage;